export enum AlarmClassificationValue {
  Alarm = 'Alarm',
  Warning = 'Warning',
}

export type AlarmClassification = keyof typeof AlarmClassificationValue
